import api from './api';

export const cmsService = {
  // ===== HERO IMAGES =====
  getHeroImages: async () => {
    const response = await api.get('/api/cms/heroes');
    return response.data;
  },

  getHeroImage: async (pageId) => {
    const response = await api.get(`/api/cms/heroes/${pageId}`);
    return response.data;
  },

  uploadHeroImage: async (formData) => {
    const response = await api.post('/api/cms/heroes', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateHeroContent: async (pageId, data) => {
    const response = await api.put(`/api/cms/heroes/${pageId}`, data);
    return response.data;
  },

  deleteHeroImage: async (pageId) => {
    const response = await api.delete(`/api/cms/heroes/${pageId}`);
    return response.data;
  },

  // ===== LABELS =====
  getLabels: async (type) => {
    const response = await api.get(`/api/cms/labels${type ? `?type=${type}` : ''}`);
    return response.data;
  },

  createLabel: async (data) => {
    const response = await api.post('/api/cms/labels', data);
    return response.data;
  },

  updateLabel: async (id, data) => {
    const response = await api.put(`/api/cms/labels/${id}`, data);
    return response.data;
  },

  deleteLabel: async (id) => {
    const response = await api.delete(`/api/cms/labels/${id}`);
    return response.data;
  },

  // ===== GALLERY =====
  getGallery: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/api/cms/gallery${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  uploadGalleryItem: async (formData) => {
    const response = await api.post('/api/cms/gallery', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateGalleryItem: async (id, data) => {
    const response = await api.put(`/api/cms/gallery/${id}`, data);
    return response.data;
  },

  deleteGalleryItem: async (id) => {
    const response = await api.delete(`/api/cms/gallery/${id}`);
    return response.data;
  },

  // ===== PROJECTS =====
  getProjects: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await api.get(`/api/cms/projects${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  getProject: async (id) => {
    const response = await api.get(`/api/cms/projects/${id}`);
    return response.data;
  },

  createProject: async (formData) => {
    const response = await api.post('/api/cms/projects', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateProject: async (id, formData) => {
    const response = await api.put(`/api/cms/projects/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteProject: async (id) => {
    const response = await api.delete(`/api/cms/projects/${id}`);
    return response.data;
  },

  addProjectImage: async (projectId, formData) => {
    const response = await api.post(`/api/cms/projects/${projectId}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteProjectImage: async (projectId, imageId) => {
    const response = await api.delete(`/api/cms/projects/${projectId}/images/${imageId}`);
    return response.data;
  },

  // ===== TESTIMONIALS =====
  getTestimonials: async () => {
    const response = await api.get('/api/cms/testimonials');
    return response.data;
  },

  createTestimonial: async (formData) => {
    const response = await api.post('/api/cms/testimonials', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateTestimonial: async (id, formData) => {
    const response = await api.put(`/api/cms/testimonials/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteTestimonial: async (id) => {
    const response = await api.delete(`/api/cms/testimonials/${id}`);
    return response.data;
  },

  // ===== SERVICES =====
  getServices: async () => {
    const response = await api.get('/api/cms/services');
    return response.data;
  },

  updateService: async (serviceKey, formData) => {
    const response = await api.put(`/api/cms/services/${serviceKey}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // ===== COMPANY INFO =====
  getCompanyInfo: async () => {
    const response = await api.get('/api/cms/company-info');
    return response.data;
  },

  updateCompanyInfo: async (data) => {
    const response = await api.put('/api/cms/company-info', data);
    return response.data;
  },

  // ===== PAGE CONTENT =====
  getPageContent: async (page) => {
    const response = await api.get(`/api/cms/content/${page}`);
    return response.data;
  },

  updatePageContent: async (page, section, data) => {
    const response = await api.put(`/api/cms/content/${page}/${section}`, data);
    return response.data;
  },

  // ===== FILE UPLOAD =====
  uploadFile: async (file, folder = 'uploads') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);
    const response = await api.post('/api/cms/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  }
};

export default cmsService;
